import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  Popconfirm,
  notification,
  Tabs,
  InputNumber,
  Tag,
  Checkbox,
  Switch,
  Select,
  DatePicker,
} from "antd";
import {
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  RetweetOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import api from '../Services/AxiosInstance';
import "../Pages/CSS/DonnesBases.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import moment from "moment";
//import { AdherentsService } from "../Services/AdherentsService";
import TabPane from "antd/es/tabs/TabPane";
import { AdherentsService } from "../Services/AdherentsService";
import { Link } from "react-router-dom";
const { Title } = Typography;

const DemandeAdhs = () => {

  const [form] = Form.useForm();
  const initialTableData = [];
  const initialNewPrestation = {
    adr: "",
    age_majorite: "",
    age_retraite: "",
    assurance: "",
    categ: "",
    codeadht: "",
    compte: "",
    compte_assur: "",
    compte_soc_mere: "",
    contact: "",
    date_adhesion: "",
    datecreation: "",
    delai_rappel_cotis: "",
    delai_suspension_cotis: "",
    delai_suspension_optique: "",
    email: "",
    intitule: "",
    ipress: "",
    lettrage: "",
    montant_cotis_mut: "",
    montant_cotis_pat: "",
    montant_cotis_sal: "",
    ninea: "",
    numcss: "",
    regul_system: "",
    secteur_activite: "",
    seuil_conso: "",
    seuil_endet: "",
    suspension_adht: "",
    tel_contact: "",
    tel_fixe: "",
    type_soc: "",
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [secteurs, setSecteurs] = useState([]);

  const [isIntituleFilled, setIsIntituleFilled] = useState(false);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  //const adherentsService = new AdherentsService();
  const adherentsService = new AdherentsService();

  useEffect(() => {
    setLoading(true);
    api.get('/Adherent/Demandes/list')
      .then((response) => {
        setTableData(response.data);
        setFilteredData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erreur lors du chargement des données de demande:', error);
        setLoading(false);
      });
  }, []);


  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createJounal = async () => {
    try {
      // Utilisation du numéro de compte sélectionné dans newPrestation.compte_rattache

      await adherentsService.addAdherents(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await adherentsService.getAllAdherents();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "La prestation a été ajouté avec succès.",
      });

    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createJounal :
  const handleSave = () => {
    createJounal();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (compte) => {
    try {
      await adherentsService.deleteAdherents(compte);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData = await adherentsService.getAllAdherents();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "La prestation a été supprimée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de la prestation.",
      });
    }
  };



  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await adherentsService.getAllAdherents(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) { }
  };

  const handleIntituleChange = (value) => {
    setNewPrestation({
      ...newPrestation,
      intitule: value,
    });
    setIsIntituleFilled(value.trim() !== ""); // Vérifie si le champ est rempli
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ""; // Retourne une chaîne vide si le numéro est vide

    // Enlève tous les caractères non numériques
    const cleanedNumber = phoneNumber.replace(/\D/g, "");

    // Applique le format attendu
    const formattedNumber = cleanedNumber
      .replace(/^(.{2})(.{3})(.{2})(.{2})/, "$1 $2 $3 $4") // Formatage
      .trim(); // Supprime les espaces au début et à la fin

    return formattedNumber;
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.compte,
      Libellé: item.intitule,
      Address: item.adr,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_founisseursDivers.xlsx");
  };

  useEffect(() => {
    // Charger les secteurs d'activité depuis l'API
    api.get('/Adherent/Secteurs/list')
      .then((response) => {
        setSecteurs(response.data); // Mettre à jour le state avec les données reçues
      })
      .catch((error) => {
        // Gérer les erreurs de requête
        console.error('Erreur lors du chargement des secteurs:', error);
      });
  }, []);
  const defaultSelectedValue = "";

  const columns = [
    {
      title: "N°",
      dataIndex: "num",
      key: "num",
      className: "small-cell",
      ellipsis: true,
      width: "15px",

      align: "center",
      render: (text) => (
        <span style={{ fontWeight: "bold", color: "#010f1c" }}>{text}</span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      className: "small-cell",
      ellipsis: true,
      width: "35px",
    },

    {
      title: "Status",
      width: "15px",
      align: "center",
      dataIndex: "suspension_adht",
      key: "suspension_adht",
      className: "small-cell",
      ellipsis: true,
      render: (text, record) => (
        <Tag color={record.suspension_adht ? "red" : "green"}>
          {record.suspension_adht ? "Suspendu" : "Actif"}
        </Tag>
      ),
    },
    {
      title: "Structure",
      dataIndex: "structure",
      key: "structure",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      width: "20px",
    },

    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      width: "5px",
      // className: 'custom-action-column'
      ellipsis: true,

      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={16}>
            <Card>
              <Row gutter={[16, 16]}>
                <Col
                  span={9}
                  style={{
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  {/*  barre de recherche */}
                  <Input
                    placeholder="Rechercher..."
                    bordered={false}
                    style={{ borderBottom: "1px solid #ccc" }}
                    onChange={(e) => handleSearch(e.target.value)}
                    onPressEnter={(e) => handleSearch(e.target.value)}
                  />
                </Col>
                <Col
                  span={15}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {/* Vos boutons d'export et d'actualisation */}
                  <Space>

                    <Link to={`/Adherents`}> <Button icon={<RetweetOutlined />}>
                      Retour
                    </Button></Link>

                    <Button onClick={handleResetAll} icon={<SyncOutlined />}>
                      Actualiser
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Card>

            <Table
              className="custom-header1-table"
              bordered
              /* size='small' */ columns={columns}
              dataSource={filteredData}
              showSorterTooltip={false}

              loading={loading}

            />
          </Col>

          <Col xs={24} xl={8}>

            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}>
                    {" "}
                    Nouvel Adherent
                  </Title>
                </div>
              }
            >
              <Form layout="vertical" size="small" onFinish={handleSave} form={form}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Date Traitement">
                      <DatePicker
                        style={{ width: "100%" }}
                        value={moment(newPrestation.date_traitement)}
                        onChange={(date) =>
                          setNewPrestation({
                            ...newPrestation,
                            date_traitement: date ? date.format("YYYY-MM-DD") : null,
                          })
                        }
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Nom Structure"
                      name="intitule"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer l'intitulé",
                        },
                      ]}
                    >
                      <Input onChange={(e) => handleIntituleChange(e.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Adresse"
                      name="adresse"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer l'adresse",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Téléphone Fixe"
                      name="tel_fixe"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer le téléphone fixe",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Contact"
                      name="contact"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer le contact",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Téléphone Contact"
                      name="tel_contact"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer le téléphone du contact",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>

                  <Col span={12}>
                    <Form.Item label="Email" name="email">
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item label="Secteur d'activité" name="secteurActivite">
                      <Select defaultValue={defaultSelectedValue}>
                        <Select.Option value="">Sélectionner un secteur</Select.Option>
                        {secteurs.map((secteur) => (
                          <Select.Option key={secteur.code} value={secteur.code}>
                            {secteur.libelle}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}> <Form.Item
                    label="Effectif"
                    name="effectif"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez entrer l'effectif",
                      },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item></Col>
                </Row>


                <Row gutter={16}>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Space>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ backgroundColor: "#010f1c", color: "white" }}
                        disabled={!isIntituleFilled}
                      >
                        Enregistrer
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </Card>


          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default DemandeAdhs;
